<template>
  <div class="main-wrapper">
    <layoutheader></layoutheader>
    <breadcrumb-doctor title="Add appointment" text="Doctor" text1="Add appointment" />
    <div class="content">
      <div class="container">
        <div class="row">
          <doctorsidebar @doctor-image="doctorImage = $event"></doctorsidebar>
          <div class="col-md-7 col-lg-8 col-xl-9 adm-scope">
            <ol class="add-appt__steps" aria-label="Steps">
              <li class="is-current"><span>1</span> Find the patient</li>
              <li><span>2</span> Pick date &amp; time</li>
            </ol>
            <!-- Same search / new-patient flow as the clinic console -->
            <patient-finder @book="book" />
          </div>
        </div>
      </div>
    </div>
    <doctorfooter />
  </div>
</template>

<script>
import "../../admin/admin.css";
import PatientFinder from "../../clinics/components/PatientFinder.vue";

export default {
  name: "doctor-add-appointment",
  components: { PatientFinder },
  data() {
    return { doctorImage: "" };
  },
  methods: {
    book(patientid) {
      const doctorid = sessionStorage.getItem("userdbid");
      this.$store.dispatch("updateAppointmentDraft", { doctorid, patientid, doctorImage: this.doctorImage });
      this.$router.push({ path: `/booking/${doctorid}`, query: { from: "doctorDashboard" } });
    },
  },
};
</script>

<style scoped>
.add-appt__steps {
  display: flex;
  gap: 24px;
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--adm-muted);
}

.add-appt__steps li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-appt__steps span {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background: var(--adm-line);
  color: var(--adm-ink-2);
}

.add-appt__steps .is-current {
  color: var(--adm-ink);
}

.add-appt__steps .is-current span {
  background: var(--adm-primary);
  color: #fff;
}
</style>
